export default {
    debugButtonExplanation: 'Zet debug modus aan of uit',
};
